import AbstractElement from "../../pages/AbstractElement";
import ReinventedColorWheel from "reinvented-color-wheel";

class AuraProduct extends AbstractElement {

    private currentFilter: string;

    constructor(template: JQuery) {
        super(template);
    }

    init(): void {
        this.currentFilter = 'static';
        this.initNav();
        this.initColorPicker();
        this.activeLink(0);
        this.changeFilter(this.currentFilter);
    }

    private initNav(): void {
        const links = this.template.find('.aura__nav').find('.aura__nav__link').toArray();
        links.map((element: HTMLElement, index: number) => {
            $(element).on('click tap', e => {
                e.preventDefault();
                this.changeFilter($(element).data('filter'));
                this.activeLink(index);
            });
        });
    }

    private activeLink(id: number): void {
        const links = this.template.find('.aura__nav').find('.aura__nav__link').toArray();
        links.map((element: HTMLElement, index: number) => {
            if (index === id) {
                $(element).addClass('active');
            } else {
                $(element).removeClass('active');
            }
        });

        if (id === 0 || id === 1 || id === 2) {
            this.template.find('.colorPicker__area').removeClass('disabled');
        } else {
            this.template.find('.colorPicker__area').addClass('disabled');
        }
    }

    private changeFilter(filter: string): void {
        const colorTotal = this.template.find('.color-area').length;
        const prevFilter = this.currentFilter;
        this.currentFilter = filter;
        for (let i = 0; i < colorTotal; i++) {
            const colorArea = this.template.find('.color-area:eq(' + i + ")");
            colorArea.removeClass(prevFilter + 'Filter');
            colorArea.addClass(this.currentFilter + 'Filter');
        }
    }

    private initColorPicker(): void {
        let colorWheel = new ReinventedColorWheel({
            appendTo: document.getElementById("colorPicker"),
            hex: "#ff0000",
            wheelDiameter: 120,
            wheelThickness: 15,
            handleDiameter: 15,
            wheelReflectsSaturation: true,
            onChange: (color: any) => {
                // console.log("color", color.hex);
                this.changeBlockBgColor(color.hex);
            }
        });
        colorWheel.redraw();
    }

    private changeBlockBgColor(color: string): void {
        const colorTotal = this.template.find('.color-area').length;
        for (let i = 0; i < colorTotal; i++) {
            const colorArea = this.template.find('.color-area:eq(' + i + ")");
            colorArea.css("background-color", color);
        }
    }
}

export default AuraProduct;